/** Guardado de borradores en el equipo (sin React, para usarlo y probarlo en cualquier lado). */
const PREFIX = "sofia.draft.";
const MAX_AGE = 7 * 24 * 3600 * 1000;

function fullKey(scope: string, key: string) { return `${PREFIX}${scope}.${key}`; }

export function readDraft<T>(scope: string, key: string): T | undefined {
  try {
    const raw = localStorage.getItem(fullKey(scope, key));
    if (!raw) return undefined;
    const d = JSON.parse(raw) as { v: T; at: number };
    if (!d || typeof d.at !== "number" || Date.now() - d.at > MAX_AGE) { localStorage.removeItem(fullKey(scope, key)); return undefined; }
    return d.v;
  } catch { return undefined; }
}
export function writeDraft(scope: string, key: string, v: unknown) {
  try {
    if (v === undefined || v === null) localStorage.removeItem(fullKey(scope, key));
    else localStorage.setItem(fullKey(scope, key), JSON.stringify({ v, at: Date.now() }));
  } catch { /* sin almacenamiento: queda en memoria */ }
}
export function clearDraft(scope: string, key: string) { try { localStorage.removeItem(fullKey(scope, key)); } catch { /* nada */ } }

/** Borra los borradores viejos (se llama al iniciar). */
export function pruneDrafts() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (!k?.startsWith(PREFIX)) continue;
      try { const d = JSON.parse(localStorage.getItem(k) ?? "") as { at: number }; if (!d?.at || Date.now() - d.at > MAX_AGE) localStorage.removeItem(k); }
      catch { localStorage.removeItem(k); }
    }
  } catch { /* nada */ }
}


/**
 * Preferencias del usuario en este equipo (no vencen, a diferencia de los borradores): por ejemplo,
 * si usa el contador de billetes al cobrar. Van separadas por negocio y usuario.
 */
const PREF = "sofia.pref.";
export function readPref<T>(scope: string, key: string): T | undefined {
  try { const raw = localStorage.getItem(`${PREF}${scope}.${key}`); return raw ? (JSON.parse(raw) as T) : undefined; } catch { return undefined; }
}
export function writePref(scope: string, key: string, v: unknown) {
  try { localStorage.setItem(`${PREF}${scope}.${key}`, JSON.stringify(v)); } catch { /* nada */ }
}
